import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'primeng/carousel';
import { from, map, catchError } from 'rxjs';
import { SponsorsService } from '../../../views/tournaments/components/sponsors-page/services/sponsors.service';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { Sponsor } from '../../models/sponsor.models';

@Component({
  selector: 'app-sponsors-carousel',
  standalone: true,
  imports: [CommonModule, CarouselModule, TranslatePipe],
  templateUrl: './sponsors-carousel.component.html',
  styleUrl: './sponsors-carousel.component.scss',
})
export class SponsorsCarouselComponent implements OnInit {
  private readonly sponsorsService = inject(SponsorsService);
  private readonly destroyRef = inject(DestroyRef);

  sponsors = signal<Sponsor[]>([]);
  previewSponsor = signal<Sponsor | null>(null);

  responsiveOptions = [
    { breakpoint: '1024px', numVisible: 3, numScroll: 1 },
    { breakpoint: '768px', numVisible: 2, numScroll: 1 },
    { breakpoint: '560px', numVisible: 1, numScroll: 1 },
  ];

  ngOnInit(): void {
    from(this.sponsorsService.getSponsors())
      .pipe(
        map((res) => (res.data as Sponsor[]) ?? []),
        map((sponsors) =>
          sponsors.map((s) => ({
            ...s,
            logo_path: this.sponsorsService.createLinkFromLogoPath(
              s.logo_path ?? ''
            ).publicUrl,
          }))
        ),
        catchError(() => []),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((sponsors) => this.sponsors.set(sponsors));
  }

  openPreview(sponsor: Sponsor): void {
    this.previewSponsor.set(sponsor);
  }

  closePreview(): void {
    this.previewSponsor.set(null);
  }

  hasDiscount(sponsor: Sponsor): boolean {
    return !!(sponsor.discount_value || sponsor.discount_description);
  }
}
